//@ts-nocheck
import { View } from "react-native";
import MathViewFallback from "react-native-math-view/src/fallback/SvgXml";
import { useAppTheme } from "../../../useAppTheme";

type Props = {
	math: string;
	inline?: boolean;
};

const MathView = ({ math, inline }: Props) => {
	const theme = useAppTheme();

	return (
		<View style={inline ? { flexShrink: 1 } : { alignItems: "center" }}>
			<MathViewFallback
				math={math}
				color={theme.palette.text.primary}
				resizeMode="contain"
				config={{ inline }}
			/>
		</View>
	);
};

export default MathView;
